var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m10.185 3.636-.159.787-4.64 5.316a2.38 2.38 0 0 0-.454 2.347H2.588a.79.79 0 0 1-.717-.458.78.78 0 0 1 .121-.837L8.817 2.97a.79.79 0 0 1 .942-.19.78.78 0 0 1 .426.856m-2.997 10.05q-.317 0-.617-.081l-.556 2.76a.78.78 0 0 0 .426.855.79.79 0 0 0 .942-.19l1.906-2.185.234-1.16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.785 3.636a.78.78 0 0 0-.426-.856.79.79 0 0 0-.942.19l-6.825 7.82a.78.78 0 0 0-.12.837.79.79 0 0 0 .716.458h4.289l-.862 4.278a.78.78 0 0 0 .426.856.79.79 0 0 0 .942-.19l6.825-7.821a.78.78 0 0 0 .12-.837.79.79 0 0 0-.716-.458h-4.289z"
})));
SvgBolts.displayName = "SvgBolts";
export { SvgBolts as ReactComponent };
export default SvgBolts;